import Vue from 'vue'
import Router from 'vue-router'
import info from '../../src/components/info.vue';
import product from '../../src/components/product.vue';
import company from '../../src/components/company.vue';
import hlInfo from '../../src/components/hl-info.vue';
import hlProduct from '../../src/components/hl-product.vue';
import hlCompany from '../../src/components/hl-company.vue';
import hlRepair from '../../src/components/hl-repair.vue';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/info',
      name:'/info',
      component: info
    },
    {
      path: '/product',
      name:'/product',
      component: product
    },
    {
      path: '/company',
      name:'/company',
      component: company
    },
    // 护栏专用路由
    {
      path: '/hl/info',
      name: '/hl/info',
      component: hlInfo
    },
    {
      path: '/hl/product',
      name: '/hl/product',
      component: hlProduct
    },
    {
      path: '/hl/company',
      name: '/hl/company',
      component: hlCompany
    },
    {
      path: '/hl/repair',
      name: '/hl/repair',
      component: hlRepair
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js